//Module Keys
let locales = {};

//Merge Views
import login from 'Core/views/login/lan/en';
locales = { ...locales, ...login };

import confirmUser from 'Core/views/confirmUser/lan/en';
locales = { ...locales, ...confirmUser };

import forgotPassword from 'Core/views/forgotPassword/lan/en';
locales = { ...locales, ...forgotPassword };

import userAlerts from 'Core/views/userAlerts/lan/en'
locales = { ...locales,  ...userAlerts };

import videoAlert from 'Core/views/videoAlert/lan/en';
locales = { ...locales,  ...videoAlert };

import header from 'Core/containers/Header/lan/en';
locales = { ...locales,  ...header };

import forceChangePassword from 'Core/views/forceChangePassword/lan/en';
locales = { ...locales, ...forceChangePassword };

import alertLog from 'Core/views/alertLog/lan/en';
locales = { ...locales,  ...alertLog };

import downloadReport from 'Core/views/downloadReport/lan/en';
locales = { ...locales,  ...downloadReport };

import useImportNotifications from 'Core/hooks/useImportNotifications/lan/en';
locales = { ...locales,  ...useImportNotifications };

import importResultsModal from '../../views/importResultsModal/lan/en';
locales = { ...locales,  ...importResultsModal };

export default locales;
